import React from "react"
import { FaMinus, FaPlus } from "react-icons/fa"

import { Input } from "components"
import classes from "./EditorFontSize.module.scss"

const EditorFontSize = (props) => {
  const { editor } = props

  const handleFontUp = () => {
    if (value + 1 > 50) return

    editor.chain().focus().setFontSize(`${value + 1}px`).run()
  }

  const handleFontDown = () => {
    if (value - 1 < 5) return

    editor.chain().focus().setFontSize(`${value - 1}px`).run()
  }

  const value =
    Number(editor.getAttributes("textStyle").fontSize?.replace("px", "")) || 14

  return (
    <div className={classes["container"]}>
      <button
        onClick={handleFontDown}
      >
        <FaMinus />
      </button>

      <Input
        readOnly
        type="number"
        number="int"
        className={classes["input"]}
        value={value}
      />

      <button
        onClick={handleFontUp}
      >
        <FaPlus />
      </button>
    </div>
  )
}

export default EditorFontSize